import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {AppState} from './state.module';
import {CommandBusService} from './command/command-bus.service';
import {Command} from './command/command';

@Injectable()
export class StateService {

  private _snapshot: BehaviorSubject<AppState> = new BehaviorSubject<AppState>(new AppState());

  public readonly state$: Observable<AppState> = this._snapshot.asObservable();
  public readonly initialized$: Observable<boolean> = this.state$
    .filter(state => state.initialized)
    .mapTo(true)
    .first();

  public get snapshot(): AppState {
    return this._snapshot.getValue();
  }

  constructor(private commandBus: CommandBusService) {
  }

  execute(command: Command): void {
    console.log('[StateService.execute] command', command);
    const state = this.commandBus.dispatch(this.snapshot, command) as AppState;
    console.log('[StateService.execute] new orders-state', state);
    this._snapshot.next(state);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/state.service.ts